// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__8VXci","btnBlue":"button_btnBlue__Z4wMA"};